// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "mobileSidebar-gwIwx";
var _3 = "mobileSidebar__closeButton-1tjXo";
var _4 = "mobileSidebar__header-3r_NU";
var _5 = "mobileSidebar__header_title-yiikr";
var _6 = "mobileSidebar__header_backwardButton-3np8f";
var _7 = "mobileSidebar__header_moreButton-2WQKb";
var _8 = "mobileSidebar__modalTitle-1QUiL";
var _9 = "mobileSidebar__items-39xj0";
var _a = "button_opened-3OOm1";
var _b = "root-oW9DU";
var _c = "content-3GCyA";
var _d = "user-1TQew";
var _e = "user__info-3GRef";
var _f = "menu__item-2in6D";
var _10 = "menu__item_selected-1ubug";
var _11 = "icon-pTLn5";
var _12 = "item__text-382cY";
var _13 = "badge-3xjma";
export { _1 as "__esModule", _2 as "mobileSidebar", _3 as "mobileSidebar__closeButton", _4 as "mobileSidebar__header", _5 as "mobileSidebar__header_title", _6 as "mobileSidebar__header_backwardButton", _7 as "mobileSidebar__header_moreButton", _8 as "mobileSidebar__modalTitle", _9 as "mobileSidebar__items", _a as "button_opened", _b as "root", _c as "content", _d as "user", _e as "user__info", _f as "menu__item", _10 as "menu__item_selected", _11 as "icon", _12 as "item__text", _13 as "badge" }
export default { "__esModule": _1, "mobileSidebar": _2, "mobileSidebar__closeButton": _3, "mobileSidebar__header": _4, "mobileSidebar__header_title": _5, "mobileSidebar__header_backwardButton": _6, "mobileSidebar__header_moreButton": _7, "mobileSidebar__modalTitle": _8, "mobileSidebar__items": _9, "button_opened": _a, "root": _b, "content": _c, "user": _d, "user__info": _e, "menu__item": _f, "menu__item_selected": _10, "icon": _11, "item__text": _12, "badge": _13 }
